import React, { useState } from 'react';
import styles from './AddProtocol.module.css';
import { createProtocol, fetchProtocolById } from '../services/protocolService';

const AddProtocol = ({ onSave, onCancel }) => {
    const [protocolData, setProtocolData] = useState({
        companyName: '',
        description: ''
    });
    const [selectedImage, setSelectedImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleFieldChange = (field, value) => {
        setProtocolData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleImageUpload = () => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';
        fileInput.onchange = (e) => {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (event) => {
                    setSelectedImage({
                        id: Date.now(),
                        src: event.target.result,
                        alt: 'Protocol Image',
                        file: file
                    });
                };
                reader.readAsDataURL(file);
            }
        };
        fileInput.click();
    };

    const handleSave = async () => {
        if (protocolData.companyName && protocolData.description && selectedImage) {
            setLoading(true);
            setError(null);
            try {
                const result = await createProtocol({
                    company_name: protocolData.companyName,
                    description: protocolData.description,
                    logo: selectedImage.file
                });
                const newId = result.data?._id;
                if (newId) {
                    const fullData = await fetchProtocolById(newId);
                    const item = fullData.data;
                    if (onSave) {
                        onSave({
                            id: item._id,
                            title: item.company_name,
                            description: item.description,
                            image: item.logo
                        });
                    }
                } else {
                    setError('Failed to get new protocol ID');
                }
            } catch (error) {
                setError(error.message || 'Failed to create protocol');
            } finally {
                setLoading(false);
            }
        }
    };

    const isFormValid = protocolData.companyName && protocolData.description && selectedImage;

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.backSection}>
                        <button className={styles.backButton} onClick={onCancel}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M19 12H5" />
                                <path d="M12 19l-7-7 7-7" />
                            </svg>
                            Back
                        </button>
                    </div>
                    <h2>Add New Offer</h2>
                </div>

                <div className={styles.mainContent}>
                    <div className={styles.leftContent}>
                        <div className={styles.formSection}>
                            <div className={styles.formGroup}>
                                <label>Company Name:</label>
                                <input
                                    type="text"
                                    value={protocolData.companyName}
                                    onChange={(e) => handleFieldChange('companyName', e.target.value)}
                                    placeholder="Enter company name"
                                    className={styles.input}
                                />
                            </div>

                            <div className={styles.formGroup}>
                                <label>Description:</label>
                                <textarea
                                    value={protocolData.description}
                                    onChange={(e) => handleFieldChange('description', e.target.value)}
                                    placeholder="Enter protocol description"
                                    className={styles.textarea}
                                    rows="6"
                                />
                            </div>
                        </div>
                    </div>

                    <div className={styles.rightContent}>
                        <div className={styles.imageSection}>
                            <h3>Offer Image</h3>
                            {selectedImage ? (
                                <div className={styles.imageContainer}>
                                    <img src={selectedImage.src} alt={selectedImage.alt} />
                                    <button
                                        className={styles.removeButton}
                                        onClick={() => setSelectedImage(null)}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ) : (
                                <div className={styles.uploadContainer}>
                                    <div className={styles.uploadIcon}>
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="7,10 12,15 17,10" />
                                            <line x1="12" y1="15" x2="12" y2="3" />
                                        </svg>
                                    </div>
                                    <p className={styles.uploadText}>Upload Protocol Image</p>
                                    <button
                                        className={styles.uploadButton}
                                        onClick={handleImageUpload}
                                    >
                                        Choose File
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className={styles.actions}>
                    {error && <div className={styles.error}>{error}</div>}
                    <button
                        className={styles.cancelButton}
                        onClick={onCancel}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        className={styles.saveButton}
                        onClick={handleSave}
                        disabled={!isFormValid || loading}
                    >
                        {loading ? 'Saving...' : 'Save Protocol'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddProtocol; 